import Service from './Service'
import { UPLOAD, ASYNC_FILE_ZIP } from './apiUrls'

export default class UploadService extends Service {
  post (data, config) {
    let _config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
    config = Object.assign(_config, config)
    return this.axios.post(`${UPLOAD}`, data, config)
  }
  downloadZip (files) {
    return this.axios.post('file-zip', {files: files}, {responseType: 'arraybuffer'})
  }
  postDownloadZip (files, program) {
    // return this.axios.post(`${ASYNC_FILE_ZIP}`, {sources: files, download_name: files.download_name})
    let data = {
      download_name: program,
      sources: files
    }
    return this.axios.post(`${ASYNC_FILE_ZIP}`, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/UploadService.js